module.exports = __webpack_public_path__ + "img/on-boarding.e726d297.svg";